module.exports = __webpack_public_path__ + "img/user28.5af2d973.jpg";